import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.css";
import "assets/scss/dashboard.scss";
import "assets/css/charts_form_controls.css";
import React, { useState, useRef, useLayoutEffect,useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import "assets/css/grid_table.css";
import moment from "moment";
import { getDataApi, saveApi, loadApi } from "services/appApi";
import { pecaPageRows, pecaRowsPerPageOptions } from "pages/common/envPECA";
import axios from "axios";

const CustomerUCCLabel  = () => {
  let emptyRow = {
   org_id: "",
   header_id: "",
   order_number : "",
   ordered_date : "",
   order_type_id : "",
   customer_number : "",
   customer_name : "",
   ecommerce_customer_flag: "",
   customer_id: "",
   ship_to_org_id : "",
   invoice_to_org_id : "",
   order_shipping_method_code : "",
   order_shipping_method : "",
   header_status : "",
   header_status_meaning : "",
   pick_release_exc : null,
   manual_pick_release_exc : null,
   some_lines_on_hold : null,
   cust_ucc_bol_number: null,
  };

  const [rows, setRows] = useState([]);
  const [rowDialog, setRowDialog] = useState(false);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showproductDialog1, setShowProductDialog1] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [loadingIndex, setLoadingIndex] = useState(null);
  const [loadingIndex1, setLoadingIndex1] = useState(null);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loadingErrors, setLoadingErrors] = useState([]);
  const [wasDataFetchingSuccessful, setWasDataFetchingSuccessful] =useState(true);
  const [orderNumber, setOrderNumber]=useState("");
  const [startOrderDate, setStartOrderDate] = useState();
  const [endOrderDate, setEndOrderDate] = useState();
  const [message, setMessage] = useState("");
  const [message1, setMessage1] = useState("");
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [orderLines, setOrderLines] = useState({});
  const [loadingRowId, setLoadingId] = useState(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([])
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);

    const fetchRows = async () => {
      const p_param = {
        p_order_number: orderNumber,
     };
     console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/customerUCC/customerUCCLabel/selOrders");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(true);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };

    useLayoutEffect(() => {
         if(!fetchStarted.current){
        fetchStarted.current=true
        fetchRows();
         }
      }, []);
 
    const handleLoadData = async () => {
      const p_param = {
        p_order_number: orderNumber,
     };
     console.log(p_param);
      try {
        setIsLoading(true);
        const response = await loadApi(p_param,"/api/customerUCC/customerUCCLabel/selOrders");
        console.log("Fetched Data:", response.data);
        console.log(response.data[0]);
        console.log(response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            console.log("success=Y");
            setRows(response.data[1]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
            setWasDataFetchingSuccessful(true);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          setWasDataFetchingSuccessful(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        console.log("Request was cancelled by the user.");

        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
        console.error("Error fetching data:", error);
      }
    }
    };

     const handleAssignLPN = async (rowData, index) => {
      const p_param = {
        p_sales_order: rowData.order_number,
     };
     console.log(p_param);
     const updRows = [...rows];
      try {
        setLoadingIndex(index);
        const response = await loadApi(p_param,"/api/customerUCC/customerUCCLabel/assignLPN");
        console.log("Fetched Assign LPN Data:", response.data);
        console.log(response.data[0]);
        console.log("cust_ucc_bol_number: ",response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            console.log("success=Y for assign LPN");
            setMessage(response.data[2]);
            updRows[index] = {...updRows[index], cust_ucc_bol_number: response.data[1]};
            setRows(updRows);
            setLoadingIndex(null);
            setShowProductDialog(true);
          } else {
            //setRows(null);
            setMessage("");
            setLoadingIndex(null);
            const errorInfo = response.data[2];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
        } else {
          //setRows(null);
          setMessage("");
          setLoadingIndex(null);
        }

        //setRows(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadingIndex(null);
    }
    };

    const handlePrintUCCLbl = async (rowData, index) => {
      const p_param = {
        p_sales_order: rowData.order_number,
        p_sales_line_number: rowData.line_number
     };
     console.log(p_param);
      try {
        setLoadingIndex1(index);
        const response = await loadApi(p_param,"/api/customerUCC/customerUCCLabel/printUCCLabel");
        console.log("Fetched Print UCC Lbl Data:", response.data);
        console.log(response.data[0]);
        // console.log("p_conc_req_id: ",response.data[1]);
        if (response.data.length > 0) {
          let successFlag = response.data[0];
          if (successFlag === "Y") {
            console.log("success=Y for assign LPN");
            setMessage1(response.data[1]);
            setLoadingIndex1(null);
            setShowProductDialog1(true);
          } else {
            //setRows(null);
            setMessage1("");
            setLoadingIndex1(null);
            const errorInfo = response.data[1];
            // Set the error message and display the dialog
            setErrorMessage(errorInfo);
            setErrorDialogVisible(true);
          }
        } else {
          //setRows(null);
          setMessage1("");
          setLoadingIndex1(null);
        }

        //setRows(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoadingIndex1(null);
    }
    };

  const hideDialog = () => {
    setSubmitted(false);
    setRowDialog(false);
    setShowProductDialog(false);
    setShowProductDialog1(false);
    setErrorDialogVisible(false);
  };

//   const showProduct = (row) => {
//     setRow({ ...row });
//     setShowProductDialog1(true);
//     setMessage1("The Assign LPN and Print UCC button is clicked successfully!")
// }

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="row d-flex justify-content-center m-5">
        <div className="col-auto">
          <div className="card shadow-sm border-primary">
            <div className="card-header bg-primary text-white">
              <h2 className="mb-0">
              Preprint Customer UCC Label
              </h2>
            </div>
            <div className="card-body text-center">
              <h3>
                <i className="fa-duotone fa-fw fa-spin-pulse fa-loader me-3"></i>{" "}
                The page is loading...
              </h3>
            </div>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

const getLoadedHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="header-container">
      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
      Preprint Customer UCC Label
          {/* <div className="header-container p-1">
              <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
          <span className="p-input-icon-right w-full md:w-auto"> 
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto text-sm p-3"
          style={{ fontSize: '17px' }} 
        />
      </span>
          </div> */}
        </h2>
      </div>
    </React.Fragment>
  );
}
const getErrrorMsgContents = () => {
  return (
    <React.Fragment>
      <div class="row mt-5 justify-content-md-center">
        <div class="col-3">
          <div class="card border-secondary">
            <div class="card-header bg-dark text-white">
            Preprint Customer UCC Label table is Unavailable
            </div>
            <div class="card-body card-body-error rounded-bottom">
              <ul>
                {loadingErrors.map((error) => (
                  <li>
                    error
                  </li>
                ))}

              </ul>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}


 const formatDateColumn = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("DD-MMM-YYYY") : null;
  };

  const orderDateBodyTemplate = (rowData) => {
    return formatDateColumn(rowData.ordered_date);
  };

const getSearchControls = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">Search</label>
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);

const getOrderNumberControl = () => (
  <React.Fragment>
    <div className="col-auto form-group ps-2 pe-0 d-flex flex-column">
    <label className="form-label">Order Number</label>
          <InputText 
          type="text"
          id = "OrderNumber"
          name="OrderNumber" 
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Enter Order Number"
          disabled={isLoading}
          className="input-outline" />
           </div>
  </React.Fragment>
);


const getGoButtonControl = () => (
  <React.Fragment>
      {/* <div className="col-auto d-flex align-items-center justify-content-center ps-2 pt-4 mt-2 pe-0"> */}
      <div className="col-auto d-flex align-items-center justify-content-center ps-2 pe-0" style={{paddingTop:'1.9375rem'}}>
        <button
          type="button"
          className="btn btn-primary load-button"
          id={"chartAreaId"}
          onClick={handleLoadData}
          disabled={isLoading}
        >
           <i
            className={
              isLoading ? "fa-duotone fa-fw fa-rotate fa-spin" : "fa-duotone fa-fw fa-rotate"
            }
          ></i>
          <span>{isLoading ? "Loading" : "Go"}</span>
        </button>
      </div>
  </React.Fragment>
  );

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
     <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const assignLPNTemplate = (rowData, options) => {
    const isload = loadingIndex === options.rowIndex;
    return (
      <React.Fragment>
        <Button
          icon={isload ? "pi pi-spin pi-spinner" : "pi pi-list-check"}
          loading={isload}
          disabled={isload}
          className="p-button-rounded p-button-primary"
          onClick={() => handleAssignLPN(rowData, options.rowIndex)}
          tooltip="Assign LPN"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

    const assignLPNPrintUCCTemplate = (rowData, options) => {
      const isload1 = loadingIndex1 === options.rowIndex;
    return (
      <React.Fragment>
        <Button
          icon={isload1 ? "pi pi-spin pi-spinner" : "pi pi-print"}
          loading={isload1}
          disabled={isload1}
          className="p-button-rounded p-button-primary"
          onClick={() => handlePrintUCCLbl(rowData, options.rowIndex)}
          tooltip="Print UCC Lbl"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const fetchOrderLines = async (header_id) => {
      setIsLoading1(true);
      setLoadingId(header_id)
      const p_param = {
        p_header_id: header_id,
      };
      console.log(p_param);
      try {
        const response = await loadApi(
          p_param,
          "/api/customerUCC/customerUCCLabel/selOrdLines"
        );
        console.log("Fetched Order Lines:", response.data);
  
        if (response.data.length > 0) {
          const successFlag = response.data[0];
          if (successFlag === "Y") {
            setOrderLines((prevOrderLines) => ({
              ...prevOrderLines,
              [header_id]: response.data[1],
            }));
            setIsLoading1(false);
          } else {
            setOrderLines((prevOrderLines) => ({
              ...prevOrderLines,
              [header_id]: [],
            }));
          }
        } else {
          setOrderLines((prevOrderLines) => ({ ...prevOrderLines, [header_id]: [] }));
          setIsLoading1(false);
        }
      } catch (error) {
        console.error("Error fetching orderLines:", error);
      } finally {
        setIsLoading1(false);
        setLoadingId(null);
      }
    };
  
    useEffect(() => {
      const prevExpanded = prevExpanRef.current;
      const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
      newlyExpanded.forEach((header_id) => {
        if(header_id) {
          fetchOrderLines(header_id);
        }
      });
      prevExpanRef.current = expandedRowId;
    }, [expandedRowId])
   

  const drillDownTemplate = (rowData) => {
      const isExpanded = expandedRowId.includes(rowData.header_id);
  
      return (
        <Button
          icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
          className={`p-button-rounded p-button-sm ${
            isExpanded ? "p-button-danger" : "p-button-primary"
          }`}
          onClick={() => toggleRowExpansion(rowData.header_id)}
          tooltip="Detail"
          tooltipOptions={{ position: "bottom" }}
          style={{ fontSize: "1rem" }}
        />
      );
    };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

  const rowExpansionTemplate = (data) => {
      const orderLinesData = orderLines[data.header_id] || [];
      const exportCSV1 = () => {
        dt1.current.exportCSV();
      };

      const requestDateTemplate = (rowData) => {
        return formatDateColumn(rowData.request_date);
      };
  
      const sheduleDateTemplate = (rowData) => {
        return formatDateColumn(rowData.schedule_ship_date);
      };
  
      return (
        <div className="p-3">
          {loadingRowId == data.header_id && (<h6>The data is loading...</h6>)}
          {loadingRowId != data.header_id && (<>
          <div className="header-container">
            <div className="header-container p-1">
              <style>
                {`
                  input::placeholder {
                    font-size: 17px;
                  }
                `}
              </style>
              <span className="p-input-icon-right w-full md:w-auto">
                <InputText
                  type="search"
                  onInput={(e) => setGlobalFilter1(e.target.value)}
                  placeholder="Search..."
                  className="w-full lg:w-auto text-sm p-3"
                  style={{ fontSize: "17px" }}
                />
              </span>
              <Button
                icon="pi pi-upload"
                className="p-button-primary p-button-rounded"
                onClick={exportCSV1}
                tooltip="Export"
                tooltipOptions={{ position: "bottom" }}
                style={{ marginLeft: "20px", marginBottom: "10px" }}
              />
              <span style={{marginLeft: "20px"}}>
                <b>No. of Rows :</b> {orderLinesData.length}
              </span>
            </div>
          </div>
          <DataTable
            ref={dt1}
            value={orderLinesData}
            responsiveLayout="scroll"
            globalFilter={globalFilter1}
          >
            <Column body={assignLPNPrintUCCTemplate} header="Print UCC Lbl" exportable={false} style={{width:'0.75rem'}}></Column>
            <Column field="order_number" header="Order Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
            <Column field="line_ship_number" header="Line Num"  bodyStyle={{ textAlign:'right' }} sortable></Column>
            <Column
              field="ucc_lpn"
              header="UCC LPN"
              bodyStyle={{ textAlign:'right' }}
              sortable
            ></Column>
            <Column
              field="ordered_item"
              header="Item Num"
              sortable
            ></Column>
            <Column
              field="ordered_quantity"
              header="Order Quantity"
              bodyStyle={{ textAlign:'right' }}
              sortable
            ></Column>
            <Column
              field="reserved_quantity"
              header="Reserved Qty"
              bodyStyle={{ textAlign:'right' }}
              sortable
            ></Column>
            <Column
              field="request_date"
              header="Request Date"
              body={requestDateTemplate}
              sortable
            ></Column>
            <Column field="schedule_ship_date" header="Schedule Date" body={sheduleDateTemplate} sortable></Column>
            <Column field="cancelled_quantity" header="Cancelled Quantity" bodyStyle={{ textAlign:'right' }} sortable></Column>
            <Column
              field="shipped_quantity"
              header="Shipped Quantity"
              bodyStyle={{ textAlign:'right' }}
              sortable
            ></Column>
            <Column
              field="ool_subinventory"
              header="Subinventory"
              sortable
            ></Column>
            <Column field="line_status_meaning" header="Line Status" sortable></Column>
            <Column field="line_on_hold_flag" header="Line Hold?" sortable></Column>
          </DataTable>
          </>
          )}
        </div>
      );
    };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {getLoadedHeaderContents()}
      <div className="row">
      <div className="col">
        <div className="row justify-content-center">
          {getSearchControls()} 
          {getOrderNumberControl()}
          {getGoButtonControl()}
        </div>
      {!wasDataFetchingSuccessful && (
      <div className="card my-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">DXP Poll Data Files</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="order_number"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={pecaPageRows}
          rowsPerPageOptions={pecaRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          expandedRows={expandedRowId.map((header_id) =>
                rows.find((rows) => rows.header_id === header_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.header_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((header_id) => header_id !== rowId)
                    : [...prev, rowId]
                );
              }}
              rowExpansionTemplate={rowExpansionTemplate}
              responsiveLayout="scroll"
              
        >
          <Column body={drillDownTemplate} style={{ width: "3rem", textAlign: "center" }}/>
          <Column body={assignLPNTemplate} header="Assign LPN" exportable={false} style={{width:'0.75rem', paddingLeft: '25px' }}></Column>
          <Column field="order_number" header="Order Num" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="cust_ucc_bol_number" header="UCC BOL#" sortable style={{whiteSpace: 'nowrap', textAlign:'right' }}></Column>
          <Column field="customer_name" header="Customer Name" sortable style={{whiteSpace: 'nowrap' }}></Column>
          <Column field="customer_number" header="Customer Num" style={{whiteSpace: 'nowrap', textAlign:'right' }} sortable></Column>
          <Column field="order_shipping_method" header="Ship Method" style={{whiteSpace: 'nowrap' }} sortable></Column>
          <Column field="ordered_date" header="Order Date" body={orderDateBodyTemplate} style={{whiteSpace: 'nowrap' }} sortable></Column>
          <Column field="header_status" header="Order Status" style={{whiteSpace: 'nowrap' }} sortable ></Column>
          <Column field="some_lines_on_hold" header="On Hold?" style={{whiteSpace: 'nowrap' }} sortable ></Column>
        </DataTable>
      </div>
      )}
      </div>
      </div>

      <Dialog visible={showproductDialog} style={{ width: '600px' }} header="Assign LPN" modal className="p-fluid" onHide={hideDialog} footer={
        <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
      }>
                
        <p>{message}</p>

      </Dialog>
      <Dialog visible={showproductDialog1} style={{ width: '600px' }} header="Print UCC Label" modal className="p-fluid" onHide={hideDialog} footer={
        <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
      }>         
        <p>{message1}</p>

      </Dialog>
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{ width: '400px' }} 
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            </div>
    </div>
  );
};

export default CustomerUCCLabel;

